import React from "react";
import PostSideBar from "./PostSideBar";
import PostDetailsBar from "./PostDetailsBar";
import TopBar from "./TopBar";

export default function PostOverlay({ post, visible = true }) {
  if (!visible) {
    return null;
  }
  return (
    <div className="absolute lg:absolute flex max-h-screen h-full w-full z-10 overflow-hidden ">
      <TopBar />
      <PostSideBar post={post} />
      <PostDetailsBar post={post} />
    </div>
  );
}
